import { createFileRoute } from '@tanstack/react-router';

import { SecurityPage } from '@/pages/settings/security';

export const Route = createFileRoute('/settings/security')({
    component: SecurityPage,
});
